const { useState } = require("react")

const useCheckOutItem = (item) =>{
  const [checkoutItem, setcheckoutItem] = useState(item);

  return [checkoutItem, setcheckoutItem];
}

export default useCheckOutItem;